import React, {useMemo, useState} from "react";
import {keepPreviousData, useQuery, useQueryClient} from '@tanstack/react-query'
import {getRooms} from "./_requests.jsx";
import Pagination from "../../helpers/Pagination.jsx";

export default function Rooms({previousPage, _handleRoomClick}) {
    const [roomsQuery, setRoomsQuery] = useState({});
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(12);

    const { isPending, isError, error, data, isFetching, isPlaceholderData } =
        useQuery({
            queryKey: ['rooms', roomsQuery, page, perPage],
            queryFn: () => getRooms(roomsQuery, previousPage, page, perPage),
            placeholderData: keepPreviousData,
            staleTime: 1 * 60 * 1000,
            cacheTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false
        })

    const roomElements = useMemo(() => {
        if(data) {
            const roomElements = data.rooms.map((node, i) =>
                (<div key={node.id} className="col-md-4 col-sm-6">
                    <a className="d-block card-rounded overlay" href="#" onClick={(e) => {
                        e.preventDefault();
                    }}>
                        <div
                            className="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded h-100 h-300px"
                            style={{backgroundImage: `url('${node.background}')`}}
                            onClick={_handleRoomClick}
                            data-room={node.id}
                        >
                            {node.id_user === null ? (
                                <span className="badge badge-info fw-bold me-auto px-4 py-3 ms-2 mt-2">Public</span>
                            ) : (
                                <span className="badge badge-success fw-bold me-auto px-4 py-3 ms-2 mt-2">My Room</span>
                            )}
                        </div>
                    </a>
                </div>)
            )
            return roomElements;
        } else return null;
    }, [data]);

    // Page change handler
    const onRoomsPageChange = (e) => {
        let seletctedPage = e.target.dataset.page;
        // check if clicked element is a child. For example for previous and next buttons we use icons
        if(e.target.tagName.toLowerCase() === 'i') {
            seletctedPage = e.target.parentNode.dataset.page;
        }
        if(seletctedPage !== undefined && seletctedPage != page) {
            setPage(seletctedPage);
        }
    };

    return <>
        <div className="toolbar d-flex flex-stack py-3 py-lg-5" id="kt_toolbar">
            <div id="kt_toolbar_container" className=" container-xxl  d-flex flex-stack flex-wrap">
                <div className="page-title d-flex align-items-center me-3">
                    <a href={previousPage} className="btn btn-sm btn-flex btn-light btn-active-primary fw-bold me-5" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                        <i className="ki-duotone ki-black-left"></i>
                        Back
                    </a>
                    <h1 className="d-flex text-gray-900 fw-bold my-1 fs-3">
                        Select A Room
                    </h1>
                </div>
                <div className="d-flex align-items-center py-2">
                    {/*<div className="me-4">*/}
                    {/*    <a href="#" className="btn btn-sm btn-flex btn-light btn-active-primary fw-bold"*/}
                    {/*       data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">*/}
                    {/*        <i className="ki-duotone ki-filter fs-5 text-gray-500 me-1"><span className="path1"></span><span*/}
                    {/*            className="path2"></span></i>*/}
                    {/*        Filter*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>

        <div id="hkzRoomList" className="d-flex flex-column-fluid align-items-start container-xxl" >
            <div className="content flex-row-fluid">
                <div className="row g-6 g-xl-9">

                    {isPending ? (
                        <p className="text-center">Loading...</p>
                    ) : isError ? (
                        <p className="text-center text-danger">Error: {error.message}</p>
                    ) : (
                        <>

                            <div className="col-md-4 col-sm-6">
                                <a className="d-block card-rounded overlay" href={GLOBAL.root+"account/rooms/"}>
                                    <div className="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded h-100 h-300px">
                                        <div className="card h-100 flex-center bg-light-primary border-primary border border-dashed p-8">
                                            <a href={GLOBAL.root+"account/rooms/"} className="text-hover-primary fs-5 fw-bold mb-2 text-uppercase">Upload a Room</a>
                                            <div className="fs-7 fw-semibold text-gray-700">You must have/create an Account</div>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            {roomElements}

                            {data.payload.pagination.last_page > 1 &&
                                <Pagination payload={data.payload.pagination} onPageChange={onRoomsPageChange}/>}
                        </>
                    )}

                </div>
            </div>
        </div>

        <div id="kt_app_footer" className="app-footer ">
            <div className="app-container container-xxl d-flex flex-column flex-md-row flex-center flex-md-stack py-3 ">
                <div className="text-gray-900 order-2 order-md-1">
                    <span className="text-muted fw-semibold me-1">{new Date().getFullYear()}©</span>
                    <a href="https://www.hackrea.net/" target="_blank"
                       className="text-gray-800 text-hover-primary">Hackrea</a>
                </div>
                <ul className="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
                    <li className="menu-item"><a href="https://www.hackrea.net/contact/" target="_blank" className="menu-link px-2">Contact</a></li>
                </ul>
            </div>
        </div>

    </>
}